import http from '../http-common';

class DeviceGroupDataService {
  getAll() {
    return http.get("/device-group");
  }

  getAllType(id) {
    return http.get(`/device-group/type/${id}`);
  }

  get(id) {
    return http.get(`/device-group/edit/${id}`);
  }

  create(data) {
    return http.post("/device-group/add", data);
  }

  update(id, data) {
    return http.put(`/device-group/update/${id}`, data);
  }

  delete(id) {
    return http.put(`/device-group/delete/${id}`);
  }
}

export default new DeviceGroupDataService();
